module.exports = __webpack_public_path__ + "img/ngo-logo.edd3f0a1.png";